import axios from 'axios'
import Immutable from 'immutee'

import {
  getApiUrl,
  getChannelParameter,
  hasPandora,
  onClientSide,
} from '../utils/utils'

export const FETCH_FILTERSCARLOCATION = 'buyer/filters/FETCH_FILTERSCARLOCATION'
export const FETCH_FILTERSCARLOCATION_FAILURE =
  'buyer/filters/FETCH_FILTERSCARLOCATION_FAILURE'
export const FETCH_FILTERSCARLOCATION_LOADING =
  'buyer/filters/FETCH_FILTERSCARLOCATION_LOADING'

const initialState = {
  fetched: false,
  result: [],
  error: null,
  isPending: false,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_FILTERSCARLOCATION_LOADING:
      return immutable.set('isPending', true).done()

    case FETCH_FILTERSCARLOCATION:
      return immutable
        .set('result', action.payload)
        .set('requested', action.requested)
        .set('isPending', false)
        .set('fetched', true)
        .done()

    case FETCH_FILTERSCARLOCATION_FAILURE:
      return immutable
        .set('result', action.payload)
        .set('requested', action.requested)
        .set('result', [])
        .set('isPending', false)
        .set('fetched', false)
        .done()
    default:
      return state
  }
}

export function fetchFiltersCarLocation(url) {
  const requestUrl = `${getApiUrl()}filter/car/LocationSearch`
  const channelParameter = getChannelParameter()
  const pandora = hasPandora()
  const requestConfig = {
    params: {
      url,
      parentFilter: 'None',
      parentValue: channelParameter,
      pandora,
    },
  }

  return dispatch => {
    if (onClientSide()) {
      dispatch({ type: FETCH_FILTERSCARLOCATION_LOADING })
    }
    return axios
      .get(requestUrl, requestConfig)
      .then(res => {
        dispatch({
          type: FETCH_FILTERSCARLOCATION,
          payload: res.data,
          requested: { url },
        })
        return res.data
      })
      .catch(err => {
        dispatch({
          type: FETCH_FILTERSCARLOCATION_FAILURE,
          payload: err.stack,
          requested: { url },
        })
      })
  }
}
